import React, { useEffect, useState } from 'react';
import { PACKING_TYPE_LIST_ENDPOINT } from '../../../config/api'; // <-- add

function PlanningFormCard({
  materialList,
  activePlanRow,
  setActivePlanRow,
  planDetails,
  handlePlanningInput,
  handleSave,
  destinationList,
  existingPlans
}) {
  const [isMobile, setIsMobile] = useState(false);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [packingOptions, setPackingOptions] = useState([]); // <-- add


  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(PACKING_TYPE_LIST_ENDPOINT);
        const data = await res.json();
        // expect [{id, name}]
        setPackingOptions(Array.isArray(data) ? data : []);
      } catch (e) {
        console.warn('Packing types fetch failed:', e);
        setPackingOptions([]);
      }
    })();
  }, []);

  useEffect(() => {
    const updateSize = () => setIsMobile(window.innerWidth <= 768);
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useEffect(() => {
    // Check if required fields are filled for the active plan row
    if (activePlanRow) {
      const currentPlan = planDetails[activePlanRow];
      const requiredFieldsFilled = currentPlan &&
        currentPlan.planned_qty &&
        currentPlan.packing_style &&
        currentPlan.delivery_date &&
        currentPlan.destination &&
        currentPlan.priority;

      setIsSaveEnabled(requiredFieldsFilled);
    } else {
      setIsSaveEnabled(false);
    }
  }, [activePlanRow, planDetails]);

  const renderPlanningFields = (item) => (
    <div className="row g-3 mt-2">
      <div className="col-md-2 col-6">
        <label className="form-label">Planned Qty<span className="text-danger">*</span></label>
        <input
          type="text"
          inputMode="decimal"
          className="form-control"
          value={planDetails[item.material_id]?.planned_qty || ''}
          onChange={(e) => handlePlanningInput(item.material_id, 'planned_qty', e.target.value)}
          required
        />
      </div>

      <div className="col-md-3 col-6">
        <label className="form-label">Packing Style<span className="text-danger">*</span></label>
        <select
          className="form-select"
          value={planDetails[item.material_id]?.packing_style || ''} // stores ID
          onChange={(e) => handlePlanningInput(item.material_id, 'packing_style', e.target.value)}
          required
        >
          <option value="">-- Select --</option>
          {packingOptions.map(opt => (
            <option key={opt.id} value={opt.name}>{opt.name}</option>
          ))}
        </select>

      </div>

      <div className="col-md-2 col-6">
        <label className="form-label">Delivery Date<span className="text-danger">*</span></label>
        <input
          type="date"
          className="form-control"
          value={planDetails[item.material_id]?.delivery_date || ''}
          onChange={(e) => handlePlanningInput(item.material_id, 'delivery_date', e.target.value)}
          required
        />
      </div>

      <div className="col-md-3 col-6">
        <label className="form-label">Destination<span className="text-danger">*</span></label>
        <select
          className="form-select"
          value={planDetails[item.material_id]?.destination || ''}
          onChange={(e) => handlePlanningInput(item.material_id, 'destination', e.target.value)}
          required
        >
          <option value="">-- Select --</option>
          {destinationList.map(dest => (
            <option key={dest.id} value={dest.destination_city}>
              {dest.destination_city}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-2 col-6">
        <label className="form-label">Priority<span className="text-danger">*</span></label>
        <select
          className="form-select"
          value={planDetails[item.material_id]?.priority || ''}
          onChange={(e) => handlePlanningInput(item.material_id, 'priority', e.target.value)}
          required
        >
          <option value="">Select Priority</option>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
          <option value="Onhold">On Hold</option>
        </select>
      </div>

      <div className="col-md-4">
        <label className="form-label">Remark</label>
        <input
          type="text"
          className="form-control"
          value={planDetails[item.material_id]?.remark || ''}
          onChange={(e) => handlePlanningInput(item.material_id, 'remark', e.target.value)}
        />
      </div>

      <div className="col-12 d-flex justify-content-end mt-2">
        <button
          className="btn btn-success"
          onClick={handleSave}
          disabled={!isSaveEnabled}
        >
          💾 Save Plan
        </button>
      </div>
    </div>
  );

  // ... rest of the component remains the same ...
  return (
    <div className="card mt-4 shadow-sm rounded-4 border border-primary">
      <div className="card-body">
        <h6 className="card-title text-primary fw-semibold">Materials for Selected Order</h6>
        <p className="text-muted small">Fields marked with <span className="text-danger">*</span> are required</p>

        {!isMobile ? (
          <div className="table-responsive">
            <table className="table table-bordered table-sm align-middle text-nowrap">
              <thead className="table-info">
                <tr>
                  <th>#</th>
                  <th>Material</th>
                  <th>Qty</th>
                  <th>Unit</th>
                  <th>Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {materialList.map((item, index) => (
                  <React.Fragment key={item.material_id}>
                    <tr className={activePlanRow === item.material_id ? 'table-warning' : ''}>
                      <td>{index + 1}</td>
                      <td>{item.material_name}</td>
                      <td>{item.qty}</td>
                      <td>{item.unit}</td>
                      <td>{item.price}</td>
                      <td>
                        <button
                          className={`btn btn-sm ${activePlanRow === item.material_id ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                          onClick={() => setActivePlanRow(activePlanRow === item.material_id ? null : item.material_id)}
                        >
                          {activePlanRow === item.material_id ? 'Close' : 'Add Planning'}
                        </button>
                      </td>
                    </tr>
                    {activePlanRow === item.material_id && (
                      <tr>
                        <td colSpan="6">{renderPlanningFields(item)}</td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="row row-cols-1 g-3">
            {materialList.map((item, index) => (
              <div key={item.material_id} className="card border">
                <div className="card-body p-2">
                  <div className="d-flex justify-content-between">
                    <strong>{item.material_name}</strong>
                    <button
                      className={`btn btn-sm ${activePlanRow === item.material_id ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                      onClick={() => setActivePlanRow(activePlanRow === item.material_id ? null : item.material_id)}
                    >
                      {activePlanRow === item.material_id ? 'Close' : 'Add Planning'}
                    </button>
                  </div>
                  <div className="small text-muted">Qty: {item.qty} | Unit: {item.unit} | Price: ₹{item.price}</div>
                  {activePlanRow === item.material_id && <>{renderPlanningFields(item)}</>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PlanningFormCard;